module.exports = __webpack_public_path__ + "static/media/d11.62c6b54f.png";